import React from 'react';
import { formatSredniyVozrast, formatPodrostSrednayaVysota, formatPodrostGustota, validatePodrostGustota } from './utils';
import { toDecimalPoint } from '../../../utils/decimalUtils';
import DecimalInput from '../../fields/DecimalInput';

const PodrostSection = ({
  displayData,
  handbooks,
  updatePodrostItem,
  openPicker
}) => {
  return (
    <div className="group-section">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <h4>Подрост</h4>
      </div>
      <div 
        style={{ 
          overflowX: 'auto', 
          overflowY: 'visible',
          maxWidth: '100%',
          border: '1px solid #ddd',
          borderRadius: '6px'
        }}
      >
        <table className="table" style={{ 
          minWidth: '800px',
          width: 'max-content',
          marginBottom: 0
        }}>
          <thead>
            <tr>
              <th style={{ minWidth: '150px', width: '150px' }}>Состав</th>
              <th style={{ minWidth: '120px', width: '120px' }}>Средний возраст, лет</th>
              <th style={{ minWidth: '120px', width: '120px' }}>Средняя высота, м</th>
              {/* Густота подроста — в тысячах штук на гектар, как в МП: 2 000 шт./га — это 2 */}
              <th style={{ minWidth: '120px', width: '120px' }}>Густота, тыс. шт./га</th>
              <th style={{ minWidth: '120px', width: '120px' }}>Состояние</th>
            </tr>
          </thead>
          <tbody>
            {displayData.podrost.map((item, index) => (
              <tr key={item.id}>
                {/* Состав */}
                <td className="coordinate-cell" style={{ minWidth: '150px', width: '150px' }}>
                  <input
                    type="text"
                    value={item.sostavpod}
                    onChange={(e) => updatePodrostItem(item.id, 'sostavpod', e.target.value)}
                    className="form-control coordinate-field"
                    placeholder="Введите состав"
                  />
                </td>

                {/* Средний возраст */}
                <td className="coordinate-cell" style={{ minWidth: '120px', width: '120px' }}>
                  <input
                    type="number"
                    min="0"
                    max="999"
                    value={item.vozrpod}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '' || (Number.isInteger(Number(value)) && Number(value) >= 0 && Number(value) <= 999)) {
                        updatePodrostItem(item.id, 'vozrpod', value);
                      }
                    }}
                    onBlur={(e) => {
                      const formatted = formatSredniyVozrast(e.target.value);
                      updatePodrostItem(item.id, 'vozrpod', formatted);
                    }}
                    className="form-control coordinate-field"
                    placeholder="0-99"
                  />
                </td>

                {/* Средняя высота */}
                <td className="coordinate-cell" style={{ minWidth: '120px', width: '120px' }}>
                  <DecimalInput
                    value={item.hpod}
                    onChange={(e) => updatePodrostItem(item.id, 'hpod', toDecimalPoint(e.target.value))}
                    onBlur={(e) => {
                      const formatted = formatPodrostSrednayaVysota(e.target.value);
                      updatePodrostItem(item.id, 'hpod', formatted);
                    }}
                    className="form-control coordinate-field"
                    placeholder="0.0-99.9"
                  />
                </td>

                {/* Густота */}
                <td className="coordinate-cell" style={{ minWidth: '120px', width: '120px' }}>
                  <DecimalInput
                    value={item.gustpod}
                    onChange={(e) => {
                      const value = toDecimalPoint(e.target.value);
                      if (/^-?\d{0,3}(\.\d{0,2})?$/.test(value)) {
                        updatePodrostItem(item.id, 'gustpod', value);
                      }
                    }}
                    onBlur={(e) => {
                      const formatted = formatPodrostGustota(e.target.value);
                      updatePodrostItem(item.id, 'gustpod', formatted);
                    }}
                    aria-label="Густота подроста, тыс. шт./га"
                    aria-invalid={String(item.gustpod ?? '').trim() !== '' && !validatePodrostGustota(item.gustpod)}
                    className={`form-control coordinate-field ${String(item.gustpod ?? '').trim() !== '' && !validatePodrostGustota(item.gustpod) ? 'lp-error' : ''}`}
                    placeholder="0.00-999.99"
                  />
                </td>

                {/* Состояние */}
                <td className="coordinate-cell" style={{ minWidth: '120px', width: '120px' }}>
                  <div 
                    className="reference-cell"
                    onClick={() => openPicker('sostpod', 23, item.id, 'podrost')}
                    style={{ 
                      minHeight: 60, 
                      height: 'auto',
                      cursor: 'pointer',
                      background: 'transparent',
                      position: 'relative'
                    }}
                  >
                    <textarea
                      readOnly
                      value={(() => {
                        const handbook = handbooks.find(h => h.id === 23);
                        if (handbook && handbook.references && item.sostpod) {
                          const selectedOption = handbook.references.find(r => r.id.toString() === item.sostpod);
                          return selectedOption ? selectedOption.name : '';
                        }
                        return '';
                      })()}
                      placeholder="☰"
                      style={{
                        border: 'none',
                        outline: 'none',
                        resize: 'none',
                        width: '100%',
                        height: '100%',
                        background: 'transparent',
                        color: item.sostpod ? '#495057' : '#6c757d',
                        fontStyle: item.sostpod ? 'normal' : 'italic'
                      }}
                      className="form-control coordinate-field"
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PodrostSection;

